import React from "react";
import { useAuth } from "../contexts/AuthContext";
import PublicRoutes from "./PublicRoutes";
import AuthRoutes from "./AuthRoutes";
import { DataLoading } from "../components/loading";
import { ContentLayout } from "../components/contentLayout";

const Routes = () => {
  const { session, loading } = useAuth();

  if (loading)
    return (
      <ContentLayout>
        <DataLoading />
      </ContentLayout>
    );

  return session?.logado ? <AuthRoutes /> : <PublicRoutes />;
};

export default Routes;
